import React, { Component } from 'react';
import {Paper, Grid, Typography, Button, IconButton, Tooltip, Checkbox} from '@material-ui/core';
import * as Gserv from '../services/GatewayService';
// import Settings from '@material-ui/icons/Settings';
import DatasheetView from './DatasheetView';
import moment from 'moment';
import XLSX from 'xlsx';
import ExcelLogo from '../assets/ExcelLogo';

export default class OHSComplianceStatsByBranch extends Component {

    constructor(props) {
        super(props);
        this.state = {
            error: false,
            error_message: '',
            querying: true,
            stats_array: [],
            totals_obj: {},
            checkAZ: true,
            checkFM: true,
            checkQS: true,
            checkSP: true,
        }

        this.datasheetFieldSpecs = [
            { field: 'branch', headerName: 'Branch', width: 180},
            { field: 'required', align: 'center', headerName: 'Required', width: 90, sortable: false},
            { field: 'missing', align: 'center', headerName: 'Vacant', width: 90, sortable: false},
            { field: 'vacancy_perc', align: 'center', headerName: '% Vacant', width: 90, sortable: false},
            { field: 'appointed', align: 'center', headerName: 'Appointees', width: 110, sortable: false},
            { field: 'missing_cert', align: 'center', headerName: 'Missing Certificates', width: 100, sortable: false},
            { field: 'expired_cert', align: 'center', headerName: 'Expired Certificates', width: 100, sortable: false},
            { field: 'soon_to_expire_cert', align: 'center', headerName: 'Expiring Certificates', width: 100, sortable: false},
            { field: 'overall_compliance', align: 'center', headerName: 'Compliance Rating', width: 100, sortable: false},
            { field: 'branch_managers', headerName: 'Managers', width: 600},

        ]
    }

    componentDidMount = () => {
        this.refreshStats();
    };
    
    resetMe = () => {
        this.setState({error: false,error_message: '',querying: true, stats_array: []});
        this.componentDidMount();
    }

    exportMe = () => {
        // console.log('called exportMe...');
        if (this.state.stats_array.length>0){
            const dateStr = new moment().format("YYYY-MM-DD");
            var ws = XLSX.utils.json_to_sheet(this.state.stats_array);
            var wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'OHS Compliance ' + dateStr);
            //Write to browser
            XLSX.writeFile(wb,'TMS Export - OHS Compliance by Branch as at ' + dateStr + '.xlsx');
        }
    }

    handleToggleChange = (e) => {
        // console.log('e.target.value :>> ', e.target.value);
        // console.log('e.target.checked :>> ', e.target.checked);
        this.setState({[e.target.value]:e.target.checked})
    }

    refreshStats = () => {

        this.setState({querying:true})

        //set filter
        let p_p_filter = ['%'];
        if (!(this.state.checkAZ&&this.state.checkFM&&this.state.checkQS&&this.state.checkSP)){
            p_p_filter = [];
            if (this.state.checkAZ){p_p_filter.push('AZ')}
            if (this.state.checkFM){p_p_filter.push('FM')}
            if (this.state.checkQS){p_p_filter.push('QS')}
            if (this.state.checkSP){p_p_filter.push('SP')}
        }

        Gserv.sendCommand('query_ohs_compliance_stats_by_branch',this.props.gwt,{
            p_p: p_p_filter
        })
        .then(reply=>{
            
            // console.log('query_ohs_compliance_stats_by_branch reply :>> ', reply);

            if (reply.error){
                console.log('error on return from Gserv (query_ohs_compliance_stats_by_branch) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else if (reply.Result!=="Success"&&reply.statusCode!==204){
                console.log('error on return from Gserv (query_ohs_compliance_stats_by_branch) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else {

                //Work out ratios and totals here...
                let stats_array = reply.ohs_compliance_stats? reply.ohs_compliance_stats : [];
                let totals_obj = {
                    required: 0,
                    missing: 0,
                    appointed: 0,
                    appointed_requiring_cert: 0,
                    missing_cert: 0,
                    expired_cert: 0,
                    soon_to_expire_cert: 0,
                    valid_cert_on_file: 0,
                    compliance_ave: 0
                };

                for (var i = 0; i < stats_array.length; i ++){
                    stats_array[i].id = i; //add unique id
                    stats_array[i].vacancy_perc = (stats_array[i].missing / stats_array[i].required * 100).toFixed(1) + '%';

                    if (stats_array[i].p_p === 'AZ'){
                        //Apply 7 point rating system for retail branches
                        stats_array[i].overall_compliance = ((stats_array[i].appointed + stats_array[i].valid_cert_on_file) / 7 * 100);
                    } else {
                        //Apply generic / proxy system for non-retail branches
                        stats_array[i].overall_compliance =  ((stats_array[i].appointed-(0.5*(stats_array[i].expired_cert+stats_array[i].missing_cert))) / (stats_array[i].appointed + stats_array[i].missing) * 100);
                    }

                    totals_obj.compliance_ave += stats_array[i].overall_compliance;
                    // console.log('totals_obj :>> ', totals_obj.compliance_ave);

                    stats_array[i].overall_compliance = stats_array[i].overall_compliance.toFixed(0) + '%';

                    //Deprecated
                    // stats_array[i].overall_compliance = ((1-(((stats_array[i].missing? stats_array[i].missing : 0) + (stats_array[i].missing_cert? stats_array[i].missing_cert : 0) + (stats_array[i].expired_cert? stats_array[i].expired_cert : 0)) / stats_array[i].required))*100).toFixed(1) + '%';
                        
                    totals_obj.required += stats_array[i].required;
                    totals_obj.missing += stats_array[i].missing;
                    totals_obj.appointed += stats_array[i].appointed;
                    totals_obj.appointed_requiring_cert += stats_array[i].cert_required === "YES" ? stats_array[i].appointed : 0;
                    totals_obj.missing_cert += stats_array[i].missing_cert ? stats_array[i].missing_cert: 0;
                    totals_obj.expired_cert += stats_array[i].expired_cert ? stats_array[i].expired_cert : 0;
                    totals_obj.soon_to_expire_cert += stats_array[i].soon_to_expire_cert? stats_array[i].soon_to_expire_cert : 0;
                    totals_obj.valid_cert_on_file += stats_array[i].valid_cert_on_file? stats_array[i].valid_cert_on_file : 0;
                }               

                totals_obj.vacancy_perc = (totals_obj.missing / totals_obj.required * 100).toFixed(1) + '%';
                totals_obj.bad_cert_perc = ((totals_obj.appointed_requiring_cert - totals_obj.valid_cert_on_file) / totals_obj.appointed_requiring_cert * 100).toFixed(1) + '%';
                totals_obj.compliance_ave = (totals_obj.compliance_ave / stats_array.length).toFixed(1) + '%';
                // console.log('totals_obj.compliance_ave :>> ', totals_obj.compliance_ave);
                
                //Deprecated
                // totals_obj.overall_compliance = ((1 - ((totals_obj.missing + totals_obj.missing_cert + totals_obj.expired_cert) / totals_obj.required))*100).toFixed(1) + '%';

                this.setState({querying:false, stats_array: stats_array, totals_obj: totals_obj});
                
            }
        });
    }

    render() {return(
        <Grid
            container
            direction='column'
            // justifyContent='flex-start'
            // alignContent='flex-start'
            // style={{backgroundColor:'yellow'}}
        >
            <Grid item>
            <Paper
                elevation={3}
                style={{
                    // backgroundColor:'yellow',
                    width:1280
                }}
            >

                <Grid
                    container
                    // style={{backgroundColor:'yellow'}}
                    justifyContent='center'
                    alignContent='center'
                >

                    <Grid item xs={4}>
                        <div style={{display:'flex', justifyContent:'space-evenly', alignItems:"center"}}>
                            <Tooltip title="Export to Excel">
                            <span>
                            <IconButton 
                                aria-label='Export to Excel'
                                onClick={this.exportMe}
                                disabled={this.state.stats_array.length===0}
                            >
                                <ExcelLogo />
                            </IconButton>
                            </span>
                            </Tooltip>
                        </div>
                    </Grid>

                    <Grid item xs={4}>
                        <Typography
                            style={{padding:10}}
                        >
                            <b>OHS Compliance by Branch</b>
                        </Typography>
                    </Grid>

                    <Grid item xs={4}></Grid>

                </Grid>

                <hr/>

                <Grid container alignItems='center' justifyContent='center' style={{marginBottom:15}}>
                    <Grid item xs={2}></Grid>
                    <Grid item xs={8}>
                        <Grid container alignItems='center'>
                        <Checkbox
                            color='primary'
                            value="checkAZ"
                            checked={this.state.checkAZ}
                            onChange={this.handleToggleChange}
                            disabled={this.state.querying}
                        />
                        <Typography>AZ (Autozone)</Typography>

                        <Checkbox
                            color='primary'
                            value="checkFM"
                            checked={this.state.checkFM}
                            onChange={this.handleToggleChange}
                            disabled={this.state.querying}
                        />
                        <Typography>FM (QSV)</Typography>

                        <Checkbox
                            color='primary'
                            value="checkQS"
                            checked={this.state.checkQS}
                            onChange={this.handleToggleChange}
                            disabled={this.state.querying}
                        />
                        <Typography>QS (QSV)</Typography>

                        <Checkbox
                            color='primary'
                            value="checkSP"
                            checked={this.state.checkSP}
                            onChange={this.handleToggleChange}
                            disabled={this.state.querying}
                        />
                        <Typography>SP (Suppply Chain)</Typography>
                        </Grid>
                    </Grid>
                    <Grid item xs={2}>
                        <Grid container alignItems='center' justifyContent='flex-end'>
                            <Button 
                                color='primary'
                                variant='outlined'
                                onClick={this.refreshStats}
                                disabled={this.state.querying}
                                style={{marginTop:10, marginRight:10}}
                            >Refresh</Button>
                        </Grid>
                    </Grid>
                </Grid>

                {/* Datagrid goes here */}
                <DatasheetView 
                    dataset={this.state.stats_array}
                    fieldspecs={this.datasheetFieldSpecs}
                    delete={false}
                    edit={false}
                    handleDelete={null}
                    handleEdit={null}
                    loading={this.state.querying}
                    deleteHeaderName={'Delete'}
                    pagesize={10}
                    height={400}
                />
            
                {!this.state.querying&&
                <Grid 
                    container
                    justifyContent='flex-end'
                    style={{padding:15}}
                >

                    <Typography>OHS Vacancies:</Typography>&nbsp;
                    <Typography color='secondary'>{this.state.totals_obj.missing} ({this.state.totals_obj.vacancy_perc})</Typography>
                    &nbsp;&nbsp;&nbsp;
                    <Typography>Appointments with Non-compliant Certificates:</Typography>&nbsp;
                    <Typography color='secondary'>{this.state.totals_obj.missing_cert + this.state.totals_obj.expired_cert}</Typography>
                    &nbsp;&nbsp;&nbsp;
                    <Typography>Average Compliance Rating:</Typography>&nbsp;
                    <Typography color='primary'><b>{this.state.totals_obj.compliance_ave}</b></Typography>

                </Grid>}

            </Paper>
            </Grid>

            <Grid item>
                <Typography color='secondary' style={{Width:1280,maxWidth:1280, textAlign:'center'}}>{this.state.error_message}</Typography>
                {this.state.error&&<Button color='primary' variant='outlined' onClick={this.resetMe}>Reset</Button>}
            </Grid>

        </Grid>
    )}
    
}